import axios from 'axios';
import { API_URL } from '../constants/index.js';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

const wrap = (method, url, data) => axios({
	method,
	url: `${API_URL}${url}`,
	data,
	params: method === 'get' ? data : undefined,
});

export function getBookableJourneys(params = {}) {
	return wrap('get', '/bookable_journeys', params);
}

export function getBookableJourneysAdmin(params = {}) {
	return wrap('get', '/bookable_journeys', { admin_list: 'true', per_page: 50, ...params });
}

export function getBookableJourneyAdmin(slug) {
	return wrap('get', `/bookable_journeys/${slug}`);
}

export function createBookableJourney(data) {
	return wrap('post', '/bookable_journeys', { bookable_journey: data });
}

export function updateBookableJourney(slug, data) {
	return wrap('put', `/bookable_journeys/${slug}`, { bookable_journey: data });
}

export function deleteBookableJourney(slug) {
	return wrap('delete', `/bookable_journeys/${slug}`);
}

export function bulkUpdateBookableJourneyAvailability(slugs, availableMonths, channel = 'both') {
	return wrap('put', '/bookable_journeys/bulk_availability', {
		slugs,
		channel,
		available_months: availableMonths,
	});
}
